<template>
  <div class="chat-query-by-user">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-input v-model="userId" placeholder="请输入用户ID"></el-input>
      </el-col>
      <el-col :span="8">
        <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>
      <el-col :span="4" style="display: flex; justify-content: flex-start;">
        <el-button type="primary" @click="queryChatRecords" icon="el-icon-search">查询</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <ChatHistoryDisplay :userId="search.userId" :dateRange="search.dateRange" />
  </div>
</template>

<script>
import ChatHistoryDisplay from '@/components/ChatHistoryDisplay.vue';

export default {
  components: {
    ChatHistoryDisplay
  },
  data() {
    return {
      userId: '',
      dateRange: null,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          const twoMonthsAgo = new Date();
          twoMonthsAgo.setTime(twoMonthsAgo.getTime() - 3600 * 1000 * 24 * 60); // 60天前
          return time.getTime() > today.getTime() || time.getTime() < twoMonthsAgo.getTime();
        },
        shortcuts: [{
          text: '近1周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近2周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近1月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近2月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      search: {
        userId: '',
        dateRange: null
      }
    };
  },
  computed: {
  },
  mounted() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
    
    this.dateRange = [
      this.formatDate(start),
      this.formatDate(end)
    ];
  },
  methods: {
    queryChatRecords() {
      this.search.userId = this.userId;
      this.search.dateRange = this.dateRange;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
  }
};
</script>

<style lang="less" scoped>
.chat-query-by-user {
  padding: 20px;
}

</style>